import React, { useEffect, useState } from "react";
import { format } from "date-fns";
import { ReactComponent as DownloadIcon } from "Assets/svg/download2.svg";
import PaginationComponent from "Components/common/PaginationComponent";
import makeApi, { URLS } from "Utils/apiURL";
import Utils from "Utils/utils";
import "./styles.scss";

const tableHeaders = [
  {
    text: "Invoice",
    key: "invoice",
  },
  {
    text: "Status",
    key: "status",
  },
  {
    text: "Amount",
    key: "amount",
  },
  {
    text: "Date",
    key: "created",
  },
  {
    text: "",
    key: "actions",
  },
];

const LoadingRows = () => {
  return Array.from({ length: 8 }).map((_, index) => {
    return (
      <tr key={`loading-${index}`}>
        <td className="invoice">
          <div className="linear-background" />
        </td>
        <td className="status">
          <div className="linear-background" />
        </td>
        <td className="amount">
          <div className="linear-background" />
        </td>
        <td className="created">
          <div className="linear-background" />
        </td>
        <td className="actionsWrapper">
          <div className="linear-background" />
        </td>
      </tr>
    );
  });
};

const BillingHistory = () => {
  const [isLoading, setLoading] = useState(true);
  const [billingHistory, setBillingHistory] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const handlePagination = pageObj => {
    const newPage = pageObj.selected + 1;
    setCurrentPage(newPage);
    setLoading(true);
    fetchInvoices(
      currentPage > newPage
        ? { prev: billingHistory[0]?.invoice }
        : { next: billingHistory[billingHistory.length - 1]?.invoice }
    );
  };

  const fetchInvoices = async (pageParams = {}) => {
    const config = {
      url: URLS.getBillingHistory,
      method: "POST",
      data: { limit: 100, ...pageParams },
    };
    const response = await makeApi(config);
    setBillingHistory(response.data?.invoices ?? []);
    setLoading(false);
  };

  useEffect(() => {
    fetchInvoices();
  }, []);

  return (
    <div className="billingHistory">
      <table>
        <thead>
          <tr>
            {tableHeaders.map(tableHeader => {
              const { text, key } = tableHeader;
              return <th key={key}>{text}</th>;
            })}
          </tr>
        </thead>
        {(isLoading || billingHistory.length > 0) && (
          <tbody>
            {isLoading ? (
              <LoadingRows />
            ) : (
              billingHistory.map(data => {
                const { invoice, status, amount, created, invoiceUrl } = data;
                return (
                  <tr key={invoice}>
                    <td className="invoice">{invoice}</td>
                    <td className="status">
                      <span className={`tag ${status.toLowerCase()}`}>
                        {status.toLowerCase()}
                      </span>
                    </td>
                    {/* amount in cents */}
                    <td className="amount">
                      $
                      {Utils.formatNumberToStringInUSFormat(
                        parseInt(amount / 100)
                      )}
                    </td>
                    <td className="created">
                      {/* date comes in epoch time in seconds */}
                      {format(new Date(created * 1000), "LLLL dd, yyyy")}
                    </td>
                    <td className="actions">
                      <div className="actionsWrapper">
                        <a href={invoiceUrl} target="_blank" rel="noreferrer">
                          <DownloadIcon
                            title="Download CSV"
                            className="downloadIcon"
                          />
                        </a>
                      </div>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        )}
      </table>
      {billingHistory.length === 0 && !isLoading && (
        <div className="noContent">No Data Available</div>
      )}
      <PaginationComponent
        totalPages={1} // total invoices not known, pagination will not show, keeping it for now
        loading={isLoading}
        callback={handlePagination}
        currentPage={currentPage}
      />
    </div>
  );
};

export default BillingHistory;
